// import React, { useState, useEffect } from 'react';
// import { Link } from 'react-router-dom';
// import { useAuth } from '../../Common/Configurations/AuthContext';
// import apiService from '../../Common/Configurations/APIService';
// import config from '../../Common/Configurations/APIConfig';
// import moment from 'moment';
// import './MyBookings.css';

// const MyBusBookings = () => {
//     const { user } = useAuth();
//     const [bookings, setBookings] = useState([]);
//     const [loading, setLoading] = useState(true);
//     const [error, setError] = useState('');
//     const [pageSize, setPageSize] = useState(20);
//     const [pageNumber, setPageNumber] = useState(1);

//     useEffect(() => {
//         const getBookings = async () => {
//             if (!user?.id) {
//                 setLoading(false);
//                 setError("User not found. Please log in again.");
//                 return;
//             }

//             try {
//                 const response = await apiService.post(`${config.GETUSERBUSBOOKINGS}/${user?.id}`, pageSize, pageNumber);
//                 console.log("Bus Bookings Response:", response);
//                 setBookings(response);
//             } catch (err) {
//                 setError("Could not fetch your flight bookings. Please try again later.");
//                 console.error("Failed to fetch flight bookings:", err);
//             } finally {
//                 setLoading(false);
//             }
//         };

//         getBookings();
//     }, [user, pageSize, pageNumber]);

//     const renderStatusBadge = (status) => {
//         let badgeClass = 'bg-secondary';
//         switch (status?.toUpperCase()) {
//             case 'CONFIRMED':
//             case 'SUCCESS':
//                 badgeClass = 'bg-success';
//                 break;
//             case 'PENDING':
//             case 'HOLD':
//                 badgeClass = 'bg-warning text-dark';
//                 break;
//             case 'CANCELLED':
//             case 'FAILED':
//                 badgeClass = 'bg-danger';
//                 break;
//             default:
//                 break;
//         }
//         return <span className={`badge ${badgeClass}`}>{status}</span>;
//     };


//     const parsePnr = (pnr) => {
//         if (!pnr || typeof pnr !== 'string') {
//             return 'Pending';
//         }
//         try {
//             const parsed = JSON.parse(pnr);
//             // Get the first value from the parsed object, e.g., "EREB7M"
//             const pnrValue = Object.values(parsed)[0];
//             return pnrValue || 'Pending';
//         } catch (error) {
//             // If it's not a valid JSON, it might be an empty string or already formatted
//             return pnr.trim() ? pnr : 'Pending';
//         }
//     };
// return (
//   <div className="main-content">
//     <div className="bookings-card">
//       {loading ? (
//         <div className="text-center p-2">
//           <div className="spinner-border text-primary" role="status">
//             <span className="visually-hidden">Loading...</span>
//           </div>
//           <p className="mt-2">Loading your bookings...</p>
//         </div>
//       ) : error ? (
//         <div className="alert alert-danger">{error}</div>
//       ) : (
//         <div className="table-responsive">
//           <table className="table table-hover align-middle">
//             <thead className="table-light">
//               <tr>
//                 <th>S No</th>
//                 <th>Booking No</th>
//                 <th>Journey</th>
//                 <th>Journey Details</th>
//                 <th>Departure</th>
//                 <th>Booking Status</th>
//                 <th>Payment Status</th>
//                 <th>Total Price</th>
//                 <th>Action</th>
//               </tr>
//             </thead>

//             <tbody>
//               {bookings.length > 0 ? (
//                 bookings.map((booking, index) => {
//                   // Safely access nested properties from the response
//                   const searchRequest = booking.flightSearchRequest;
//                   const journeyPoints = searchRequest?.flightTravelerPoints?.[0];
//                   const from = journeyPoints?.from;
//                   const to = journeyPoints?.to;
//                   const journeyType = searchRequest?.journeyType;

//                   return (
//                     <tr key={booking.flightBookingId}>
//                       <td>{index + 1}</td>
//                       <td>
//                         <strong>{booking.bookingNo}</strong>
//                         <br />
//                         <small className="text-muted">
//                           PNR: {parsePnr(booking.pnr)}
//                         </small>
//                       </td>
//                       <td>
//                         <strong>
//                           {from} → {to}
//                         </strong>
//                       </td>
//                       <td>
//                         <strong>{journeyType}</strong>
//                       </td>
//                       <td>
//                         {moment(booking.departureDate).format(
//                           "DD MMM YYYY, h:mm A"
//                         )}
//                       </td>
//                       <td>{renderStatusBadge(booking.bookingStatus)}</td>
//                       <td>{renderStatusBadge(booking.paymentStatus)}</td>
//                       <td>
//                         <strong>{booking.totalPrice}</strong>
//                       </td>
//                       <td>
//                         <Link
//                           to={`/my-flight/booking/${booking.flightBookingId}`}
//                           className="btn btn-sm btn-outline-primary"
//                         >
//                           View Details
//                         </Link>
//                       </td>
//                     </tr>
//                   );
//                 })
//               ) : (
//                 <tr>
//                   <td colSpan="9" className="text-center py-4">
//                     No records found.
//                   </td>
//                 </tr>
//               )}
//             </tbody>
//           </table>
//         </div>
//       )}
//     </div>
//   </div>
// );
// }
// export default MyBusBookings;

import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { useAuth } from '../../Common/Configurations/AuthContext';
import apiService from '../../Common/Configurations/APIService';
import config from '../../Common/Configurations/APIConfig';
import moment from 'moment';
import './MyBookings.css';

const MyBusBookings = () => {
    const { user } = useAuth();
    const [bookings, setBookings] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState('');
    
    // Pagination state (kept from your code)
    const [pageSize, setPageSize] = useState(20);
    const [pageNumber, setPageNumber] = useState(1);

    useEffect(() => {
        const getBookings = async () => {
            if (!user?.id) {
                setLoading(false);
                setError("User not found. Please log in again.");
                return;
            }

            try {
                const response = await apiService.post(`${config.GETUSERBUSBOOKINGS}/${user?.id}`, pageSize, pageNumber);
                console.log("Bus Bookings Response:", response);
                setBookings(response);
            } catch (err) {
                setError("Could not fetch your bus bookings. Please try again later.");
                console.error("Failed to fetch bus bookings:", err);
            } finally {
                setLoading(false);
            }
        };

        getBookings();
    }, [user, pageSize, pageNumber]);

    const renderStatusBadge = (status) => {
        let badgeClass = 'bg-secondary';
        // Handle null/undefined gracefully
        const safeStatus = status ? status.toUpperCase() : 'UNKNOWN';

        switch (safeStatus) {
            case 'CONFIRMED':
            case 'SUCCESS':
                badgeClass = 'bg-success';
                break;
            case 'PENDING':
            case 'HOLD':
                badgeClass = 'bg-warning text-dark';
                break;
            case 'CANCELLED':
            case 'FAILED':
                badgeClass = 'bg-danger';
                break;
            default:
                break;
        }
        return <span className={`badge ${badgeClass}`}>{safeStatus}</span>;
    };

    return (
        <div className="main-content">
            <div className="bookings-card">
                {loading ? (
                    <div className="text-center p-2">
                        <div className="spinner-border text-primary" role="status">
                            <span className="visually-hidden">Loading...</span>
                        </div>
                        <p className="mt-2">Loading your bookings...</p>
                    </div>
                ) : error ? (
                    <div className="alert alert-danger">{error}</div>
                ) : (
                    <div className="table-responsive">
                        <table className="table table-hover align-middle">
                            <thead className="table-light">
                                <tr>
                                    <th>S No</th>
                                    <th>Booking No</th>
                                    <th>Route</th>
                                    <th>Passenger</th>
                                    <th>Departure Date</th>
                                    <th>Booking Status</th>
                                    <th>Payment Status</th>
                                    <th>Total Price</th>
                                    <th>Action</th>
                                </tr>
                            </thead>

                            <tbody>
                                {bookings.length > 0 ? (
                                    bookings.map((booking, index) => {
                                        // 1. Extract data based on Bus Response structure
                                        const { 
                                            busBookingId, 
                                            bookingNo, 
                                            sourceCity, 
                                            destinationCity, 
                                            departureDate, 
                                            bookingStatus, 
                                            paymentStatus, 
                                            totalPrice,
                                            passengerName,
                                            pnr
                                        } = booking;

                                        return (
                                            <tr key={busBookingId}> 
                                                <td>{index + 1}</td>
                                                <td>
                                                    <strong>{bookingNo}</strong>
                                                    {pnr && (
                                                        <>
                                                            <br />
                                                            <small className="text-muted">
                                                                PNR: {pnr}
                                                            </small>
                                                        </>
                                                    )}
                                                </td>
                                                <td>
                                                    <strong>
                                                        {sourceCity} → {destinationCity}
                                                    </strong>
                                                </td>
                                                <td>
                                                    {passengerName}
                                                </td>
                                                <td>
                                                    {/* Format date: 20 Dec 2025 */}
                                                    {moment(departureDate).format("DD MMM YYYY")}
                                                    <br/>
                                                    {/* Format time: 10:00 PM */}
                                                    <small className="text-muted">
                                                        {moment(departureDate).format("h:mm A")}
                                                    </small>
                                                </td>
                                                <td>{renderStatusBadge(bookingStatus)}</td>
                                                <td>{renderStatusBadge(paymentStatus)}</td>
                                                <td>
                                                    <strong>₹{totalPrice}</strong>
                                                </td>
                                                <td>
                                                    {/* Updated Link to Bus Details */}
                                                    <Link
                                                        to={`/bus/booking/${busBookingId}`}
                                                        className="btn btn-sm btn-outline-primary"
                                                    >
                                                        View Details
                                                    </Link>
                                                </td>
                                            </tr>
                                        );
                                    })
                                ) : (
                                    <tr>
                                        <td colSpan="9" className="text-center py-4">
                                            No bus bookings found.
                                        </td>
                                    </tr>
                                )}
                            </tbody>
                        </table>
                    </div>
                )}
            </div>
        </div>
    );
}

export default MyBusBookings;